import { composeReducers } from 'common/util';
import lodash from 'lodash';

import {
    LOAD_EXTERNAL_USERS,
    LOAD_EXTERNAL_USER,
    WAITING_FOR_LOAD_EXTERNAL_USER,
    WAITING_FOR_LOAD_EXTERNAL_USERS,
    REMOVE_EXTERNAL_USER,
    CLEAR_EXTERNAL_USER,
    SET_EXISTING_USER
} from 'binder/actions/externalUsers';

export function loadExternalUsers(state, action) {
    if (!action || action.type !== LOAD_EXTERNAL_USERS) {
        return state;
    }

    const externalUsers = action.payload;
    const binderUsers = state.binder.users;

    externalUsers.forEach(user => {
        const existingUser = binderUsers.find(u => u.id === user.id);
        if (!existingUser) {
            binderUsers.push({
                id: user.id,
                sub: user.sub,
                displayName: user.displayName,
                institutionId: user.institutionId,
                firstName: user.firstName,
                lastName: user.lastName,
            });
        }
    });

    return {
        ...state,
        externalUsers,
        binder: {
            ...state.binder,
            users: binderUsers,
        }
    };
}

export function waitingForLoadExternalUsers(state, action) {
    if (!action || action.type !== WAITING_FOR_LOAD_EXTERNAL_USERS) {
        return state;
    }

    const loading = action.payload;

    if (loading) {
        return {
            ...state,
            externalUsersLoading: loading,
        };
    } else {
        return lodash.omit(state, 'externalUsersLoading');
    }
}

export function loadExternalUser(state, action) {
    if (!action || action.type !== LOAD_EXTERNAL_USER) {
        return state;
    }

    const externalUser = action.payload;

    return {
        ...state,
        'existingExternalUser': {
            ...externalUser,
        }
    };
}

export function waitingForLoadExternalUser(state, action) {
    if (!action || action.type !== WAITING_FOR_LOAD_EXTERNAL_USER) {
        return state;
    }

    return {
        ...state,
        existingExternalUser: {
            ...state.existingExternalUser,
            loading: action.payload,
        }
    };
}

export function removeExternalUser(state, action) {
    if (!action || action.type !== REMOVE_EXTERNAL_USER) {
        return state;
    }

    const [removedUser] = action.payload;
    if (lodash.isNil(removedUser) || lodash.isEmpty(removedUser)) {
        return state;
    }
    const { id } = removedUser;
    const { externalUsers } = state;
    const newExternalUsers = externalUsers.filter(user => user.id !== id);
    const binderUsers = state.binder.users.filter(user => user.id !== removedUser.id);

    return {
        ...state,
        externalUsers: newExternalUsers,
        binder: {
            ...state.binder,
            users: binderUsers,
        }
    };
}

export function setExistingUser(state, action) {
    if (!action || action.type !== SET_EXISTING_USER) {
        return state;
    }

    const user = action.payload;

    return {
        ...state,
        existingExternalUser: user
    };
}

export function clearExternalUser(state, action) {
    if (!action || action.type !== CLEAR_EXTERNAL_USER) {
        return state;
    }

    return lodash.omit(state, 'existingExternalUser');
}

export default composeReducers(
    loadExternalUsers,
    loadExternalUser,
    waitingForLoadExternalUser,
    waitingForLoadExternalUsers,
    removeExternalUser,
    setExistingUser,
    clearExternalUser,
);
